<template>
  <div class="page-wrapper downlinerep-wrapper" ref="downlineRepContainer">
    <div class="container-fluid">
      <breadcrumb :items="breadcrumbItems" />
      <pending-items-internal :title="false" />
      <div class="page-title text-upper-case">
        <h1>Downline Pending Activation</h1>
        <button class="clear-search" @click="clearDownline">
          Clear Search
        </button>
      </div>
      <pending-downline-rep-list-filter :filters="filterQuery" @onSearch="filterData" />
      <div class="downlinedata-card">
        <div
          class="align-items-center top-pagination"
        >
          <!-- <page-result :rows.sync="rows" /> -->
          <pagination :rows.sync="rows" :filters="filterQuery" />
        </div>
        <downline-rep-list-table
          :rows.sync="rows"
          :is-initial-load="false"
          @onSuccess="getAll(filterQuery)"
        />
        <div
          class=" align-items-center"
        >
          <!-- <page-result :rows.sync="rows" /> -->
          <pagination :rows.sync="rows" :filters="filterQuery" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/resource/Api";
import Helper from "@/resource/Helper";
import DownlineRepListTable from "@/views/DownlineRep/partials/DownlineRepListTable";
import PendingDownlineRepListFilter from "./partials/PendingDownlineRepFilter.vue";
import PendingItemsInternal from "../Dashboard/partials/PendingItemsInternal.vue"
export default {
  name: "PendingDowlineRepList",
  components: {
    DownlineRepListTable,
    PendingDownlineRepListFilter,
    PendingItemsInternal
  },
  data: () => ({
    rows: [],
    filterQuery: {
      agent_fname: "",
      agent_lname: "",
      agent_code: "",
      agent_state: "",
      agent_phone: "",
      agent_email: "",
      upline_code: "",
      upline_name: "",
      group_id: "",
      agent_status: "P",
    },
    breadcrumbItems: [{ title: "Dowline Rep", active: true }],
  }),
  methods: {
    clearDownline() {
      this.filterQuery = {
        agent_fname: "",
        agent_lname: "",
        agent_code: "",
        agent_state: "",
        agent_phone: "",
        agent_email: "",
        upline_code: "",
        upline_name: "",
        group_id: "",
        agent_status: "P",
        page_size:10
      };
      this.getAll();
    },
    filterData(filters) {
      this.filterQuery = filters;
      this.getAll(this.filterQuery);
    },
    getAll(filters = null) {
      let url;
      let loader = this.$loading.show();
      if (filters) {
        let filterUrl = Helper.objToUrlParams(filters);
        url = `v2/get-all-active-downline-reps?${filterUrl}`;
      } else {
        url = `v2/get-all-active-downline-reps?agent_status=P&page_size=10`;
      }
      Api.get(url)
        .then((res) => {
          this.rows = res.data;
        })
        .catch(() => {
          this.rows = [];
          console.log("error");
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
  created() {
    this.getAll();
  },
};
</script>
<style src="@/assets/css/downline-reps.css"></style>
